import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend, { HttpBackendOptions } from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init<HttpBackendOptions>({
    debug: false,
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],

    // if true  : when lng='en-US' and 'en' is supported, pass 'en-US'
    // if false : when lng='en-US' and 'en' is supported, pass 'en'
    nonExplicitSupportedLngs: true,

    // 'all' : when lng='en-US', load ['en-US', 'en']
    // 'currentOnly' : when lng='en-US', load 'en-US'
    // 'languageOnly' : when lng='en-US', load 'en'
    load: 'all',

    ns: [
      'auth',
      'budget',
      'cahierJournal',
      'carnet',
      'common',
      'countries',
      'dashboard',
      'eleve',
      'emploiDuTemps',
      'invoice',
      'lockedPage',
      'onboarding',
      'planner',
      'referentiel',
      'registreAppel',
      'schoolyearSettings',
      'sequence',
      'userSettings',
      'zone',
    ],
    react: {
      useSuspense: true,
    },
    interpolation: {
      escapeValue: false, // not needed for react
    },
    backend: {
      queryStringParams: { v: __APP_VERSION__ },
    },
  });

i18n.services.formatter?.add('lowercase', value => value.toLowerCase());

export default i18n;
